import { CAN_SIGNALS, canSignalSource, resolveCanSignals, parseCanSignals } from '@trackizy/formatters';

export function buildRows(device, latestAttributes) {
  const attrs = latestAttributes && typeof latestAttributes === 'object' ? latestAttributes : {};
  const resolved = resolveCanSignals(device, attrs);
  return CAN_SIGNALS.map((def) => {
    const src = canSignalSource(device, def.key);
    return { key: def.key, unit: def.unit, kind: def.kind, source: src.source, value: resolved[def.key].value, family: src.family,
      overridden: src.overridden, hidden: src.hidden, scale: src.scale, offset: src.offset, truthy: src.truthy };
  });
}

export function applyRowEdit(override, key, patch) {
  const next = { ...parseCanSignals(override) };
  if (patch.reset) { delete next[key]; return next; }
  if (patch.hidden === true) { next[key] = null; return next; }
  const prev = next[key] && typeof next[key] === 'object' ? next[key] : {};
  const spec = { ...prev };
  if (patch.source !== undefined) spec.source = patch.source;
  if (patch.scale !== undefined) { if (patch.scale === null) delete spec.scale; else spec.scale = patch.scale; }
  if (patch.offset !== undefined) { if (patch.offset === null) delete spec.offset; else spec.offset = patch.offset; }
  if (patch.truthy !== undefined) { if (patch.truthy === null) delete spec.truthy; else spec.truthy = patch.truthy; }
  if (!spec.source) { delete next[key]; return next; }
  next[key] = spec;
  return next;
}

export function setFamily(override, familyId) {
  const next = { ...parseCanSignals(override) };
  if (familyId) next.family = familyId; else delete next.family;
  return next;
}

export function overridePayload(override) {
  const o = parseCanSignals(override);
  return Object.keys(o).length === 0 ? undefined : o;
}

export function attributeKeysOf(latestAttributes) {
  return Object.keys(latestAttributes && typeof latestAttributes === 'object' ? latestAttributes : {}).sort((a, b) => a.localeCompare(b));
}
